// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xjs3S3 {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.n6q2Pe {
  gap: var(--spacing-3);
  display: flex;
  flex-direction: column;
}

.JrpvIy {
  width: 100%;
}

.H1iJu8,
.c7oKmt,
.qA6IYI {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
}

.lUUoXR,
.Lu_1Bh {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--type-subtitle-md-font-weight);
  line-height: 24px;
  color: var(--text-neutral-dark);
}

.VwsGE9 {
  color: var(--text-neutral-stronger);
}

.KIiYrA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  width: 100%;
  box-sizing: border-box;
  padding: var(--spacing-2);
  border-radius: var(--radius-s);
  background: var(--surface-neutral-pale, #fafafa);
}

.dlmnhR {
  background: var(--surface-primary-subtle, #ffeee5);
}

.fgV0si {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  min-width: 0;
}

.EGoqTZ {
  flex: 0 0 auto;
  font-size: var(--type-title-sm-font-size, 20px);
  line-height: 26px;
}

.is9AKE {
  font-family: var(--font-family-base);
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--font-weight-semibold);
  line-height: 24px;
  color: var(--text-neutral-dark);
}

.Tp8fMu {
  flex: 0 0 auto;
  --toggle-track-off: #e6e6e6;
  --toggle-knob-off: #666666;
  --toggle-knob-on: #ffffff;
}

.dwC2Qp {
  background-color: var(--surface-neutral-pale, #fafafa);
}

.dwC2Qp .OGZBCf {
  font-size: 16px;
}

.dwC2Qp .zvTmUX {
  line-height: 24px;
}

.c7oKmt .n9tqi_ {
  margin: 0;
}

.ZNYGfR {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.VAdYGC {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  margin: 0;
}

.Jjyhq4 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 520px;
  max-width: 100%;
}

.v7GTLZ {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1);
}

.bYnkgV {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.HJOo55 {
  color: var(--text-neutral-stronger);
}

.VZcHAm {
  display: inline-flex;
  align-items: center;
}

.nCPg4l {
  font-size: var(--font-size-sm);
  width: 12px;
  height: 12px;
  color: var(--text-neutral-stronger);
  cursor: help;
}

.jYeAv8 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
}

.qIo9ds {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.vyI3LC {
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--type-subtitle-md-font-weight);
  color: var(--text-neutral-dark);
  margin: 0;
}

.jRN7xM {
  font-weight: var(--font-weight-regular);
}

.z664Ls {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-sm-font-size);
  color: var(--text-neutral-strong);
  text-align: right;
}

.A7gDAc {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.KvPJzZ {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.CEpV5F {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.Oboaf6 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-s);
  height: fit-content;
}

.UxjFTZ {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-dark);
}

.n9tqi_ {
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--type-subtitle-md-font-weight);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-2);
}

.LfZ0IY {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.ybpVVZ {
  flex-direction: row;
  gap: var(--spacing-3);
}

.OGZBCf {
  font-size: var(--type-paragraph-lg-font-size);
  width: var(--spacing-2);
  height: var(--spacing-2);
}

.ohwVyu {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1);
  align-items: center;
}

.OI1d6Y {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
}

.t6IMPu {
  padding: 0 var(--spacing-0-5);
  border-radius: var(--radius-s);
  border: 1px solid var(--status-success);
  background: var(--success-green-light);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 22px;
  color: var(--text-neutral-dark);
}

.HymnA0 {
  border-top: 1px solid var(--stroke-neutral-silver);
  margin-top: var(--spacing-1);
}

.Xyince {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1-5);
  align-items: center;
}

.zvTmUX {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0;
}

.K3Zpap {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-strong);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-1);
}

.XrcIVn {
  width: 100%;
  min-width: 0;
}

.Mkaax_ {
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: var(--font-weight-regular);
  line-height: 1.6;
  color: var(--text-neutral-dark);
}

.V7IwEB {
  color: var(--link-default, #1573d3);
  text-decoration: underline;
}

.V7IwEB:hover {
  color: var(--link-hover);
}

/* Responsividade */
@media (max-width: 768px) {
  .A7gDAc {
    gap: var(--spacing-2);
  }

  .KvPJzZ {
    font-size: var(--type-paragraph-lg-font-size);
  }

  .CEpV5F {
    font-size: var(--type-paragraph-sm-font-size);
  }

  .Oboaf6 {
    padding: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/Competence/Competence.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,oCAAoC;EACpC,4CAA4C;EAC5C,gDAAgD;EAChD,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uCAAuC;EACvC,sCAAsC;EACtC,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,uCAAuC;EACvC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".wizardCardShell {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.competenceContent {\n  gap: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n}\n\n.holidayRechargeContent {\n  width: 100%;\n}\n\n.holidayFieldGroup,\n.holidayProductSection,\n.holidayTypeSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.holidayCompetenceLabel,\n.holidaySectionTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--type-subtitle-md-font-weight);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n}\n\n.holidayRequired {\n  color: var(--text-neutral-stronger);\n}\n\n.holidayTypeCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--spacing-2);\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-pale, #fafafa);\n}\n\n.holidayTypeCardSelected {\n  background: var(--surface-primary-subtle, #ffeee5);\n}\n\n.holidayTypeDescription {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  min-width: 0;\n}\n\n.holidayTree {\n  flex: 0 0 auto;\n  font-size: var(--type-title-sm-font-size, 20px);\n  line-height: 26px;\n}\n\n.holidayTypeLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--font-weight-semibold);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n}\n\n.holidayTypeToggle {\n  flex: 0 0 auto;\n  --toggle-track-off: #e6e6e6;\n  --toggle-knob-off: #666666;\n  --toggle-knob-on: #ffffff;\n}\n\n.holidayProductOption {\n  background-color: var(--surface-neutral-pale, #fafafa);\n}\n\n.holidayProductOption .radioIcon {\n  font-size: 16px;\n}\n\n.holidayProductOption .radioLabel {\n  line-height: 24px;\n}\n\n.holidayProductSection .sectionTitle {\n  margin: 0;\n}\n\n.mandatoryLegend {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.dataRechargeSubtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  width: 520px;\n  max-width: 100%;\n}\n\n.competenceLabelRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.competenceLabelText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.requiredAsterisk {\n  color: var(--text-neutral-stronger);\n}\n\n.competenceInfoTooltip {\n  display: inline-flex;\n  align-items: center;\n}\n\n.competenceInfoIcon {\n  font-size: var(--font-size-sm);\n  width: 12px;\n  height: 12px;\n  color: var(--text-neutral-stronger);\n  cursor: help;\n}\n\n.competenceHelperText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n}\n\n.identificationSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.identificationLabel {\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--type-subtitle-md-font-weight);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.identificationOptional {\n  font-weight: var(--font-weight-regular);\n}\n\n.charCounter {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-sm-font-size);\n  color: var(--text-neutral-strong);\n  text-align: right;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.summaryCard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-s);\n  height: fit-content;\n}\n\n.summaryTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.sectionTitle {\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--type-subtitle-md-font-weight);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-2);\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.rechargeTypeRadioGroup {\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.radioIcon {\n  font-size: var(--type-paragraph-lg-font-size);\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n}\n\n.radioItemContent {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  align-items: center;\n}\n\n.radioItemStack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.patBadge {\n  padding: 0 var(--spacing-0-5);\n  border-radius: var(--radius-s);\n  border: 1px solid var(--status-success);\n  background: var(--success-green-light);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: 22px;\n  color: var(--text-neutral-dark);\n}\n\n.patFacilitator {\n  border-top: 1px solid var(--stroke-neutral-silver);\n  margin-top: var(--spacing-1);\n}\n\n.radioItemWithPopover {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1-5);\n  align-items: center;\n}\n\n.radioLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.textInfo {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-strong);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.termsSection {\n  width: 100%;\n  min-width: 0;\n}\n\n.termsText {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.6;\n  color: var(--text-neutral-dark);\n}\n\n.termsLink {\n  color: var(--link-default, #1573d3);\n  text-decoration: underline;\n}\n\n.termsLink:hover {\n  color: var(--link-hover);\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .stepContent {\n    gap: var(--spacing-2);\n  }\n\n  .title {\n    font-size: var(--type-paragraph-lg-font-size);\n  }\n\n  .subtitle {\n    font-size: var(--type-paragraph-sm-font-size);\n  }\n\n  .summaryCard {\n    padding: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wizardCardShell": `Xjs3S3`,
	"competenceContent": `n6q2Pe`,
	"holidayRechargeContent": `JrpvIy`,
	"holidayFieldGroup": `H1iJu8`,
	"holidayProductSection": `c7oKmt`,
	"holidayTypeSection": `qA6IYI`,
	"holidayCompetenceLabel": `lUUoXR`,
	"holidaySectionTitle": `Lu_1Bh`,
	"holidayRequired": `VwsGE9`,
	"holidayTypeCard": `KIiYrA`,
	"holidayTypeCardSelected": `dlmnhR`,
	"holidayTypeDescription": `fgV0si`,
	"holidayTree": `EGoqTZ`,
	"holidayTypeLabel": `is9AKE`,
	"holidayTypeToggle": `Tp8fMu`,
	"holidayProductOption": `dwC2Qp`,
	"radioIcon": `OGZBCf`,
	"radioLabel": `zvTmUX`,
	"sectionTitle": `n9tqi_`,
	"mandatoryLegend": `ZNYGfR`,
	"dataRechargeSubtitle": `VAdYGC`,
	"fieldGroup": `Jjyhq4`,
	"competenceLabelRow": `v7GTLZ`,
	"competenceLabelText": `bYnkgV`,
	"requiredAsterisk": `HJOo55`,
	"competenceInfoTooltip": `VZcHAm`,
	"competenceInfoIcon": `nCPg4l`,
	"competenceHelperText": `jYeAv8`,
	"identificationSection": `qIo9ds`,
	"identificationLabel": `vyI3LC`,
	"identificationOptional": `jRN7xM`,
	"charCounter": `z664Ls`,
	"stepContent": `A7gDAc`,
	"title": `KvPJzZ`,
	"subtitle": `CEpV5F`,
	"summaryCard": `Oboaf6`,
	"summaryTitle": `UxjFTZ`,
	"radioGroup": `LfZ0IY`,
	"rechargeTypeRadioGroup": `ybpVVZ`,
	"radioItemContent": `ohwVyu`,
	"radioItemStack": `OI1d6Y`,
	"patBadge": `t6IMPu`,
	"patFacilitator": `HymnA0`,
	"radioItemWithPopover": `Xyince`,
	"textInfo": `K3Zpap`,
	"termsSection": `XrcIVn`,
	"termsText": `Mkaax_`,
	"termsLink": `V7IwEB`
};
module.exports = ___CSS_LOADER_EXPORT___;
